// Bootstrap dependencies
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'
import 'vue-good-table/dist/vue-good-table.css'
import 'vue-snotify/styles/material.css'
import 'vue-datetime/dist/vue-datetime.css'
// css
import '@/assets/global.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import {
  faBars,
  faBold,
  faCheck,
  faCloudUploadAlt,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faEyeSlash,
  faHome,
  faItalic,
  faLink,
  faListOl,
  faListUl,
  faPencilAlt,
  faPlus,
  faQuoteRight,
  faRedo,
  faSave,
  faStrikethrough,
  faTimes,
  faTools,
  faUnderline,
  faUndo,
  faUser
} from '@fortawesome/free-solid-svg-icons'
import { faEnvelope, faFile, faTrashAlt } from '@fortawesome/free-regular-svg-icons'

import App from './App'
// Vue datetime dependencies
import Datetime from 'vue-datetime'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// Vue Snotify dependencies
import Snotify from 'vue-snotify'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// Vue Good Table dependencies
import VueGoodTable from 'vue-good-table'
// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import router from './router'
import store from '@/store/index'
// Vue select dependencies
import vSelect from 'vue-select'

// Install BootstrapVue and the BootstrapVue icon components plugin
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueGoodTable)
Vue.use(Datetime)
Vue.use(Snotify)
library.add(faPlus, faCheck, faExclamationCircle, faPencilAlt, faCloudUploadAlt, faBars, faTools, faDownload,
  faFile, faTrashAlt, faExclamationTriangle, faHome, faUser, faSave, faEnvelope, faTimes, faEdit, faEyeSlash,
  faBold, faItalic, faStrikethrough, faUnderline, faListUl, faListOl, faQuoteRight, faUndo, faRedo, faLink)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    notifySuccess (title, message) {
      this.$snotify.success(message, title, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true
      })
    },
    notifyError (title, message) {
      this.$snotify.error(message, title, {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true
      })
    },
    isNullOrUndefined (arg) {
      return arg === null || arg === undefined || arg === 'undefined' || arg === ''
    },
    checkManagerInGroup (user, id) {
      return user.userRole === 'Manager' && user.grups.filter(grup => (grup.id === id)).length >= 1
    },
    checkTicketEditable (user, ticket) {
      return !['Tancada', 'Descartada', 'Duplicada'].includes(ticket.estat.displayname)
    },
    checkUserInTicket (user, ticket) {
      return ticket.usuaris.some(u => u.codi_xarxa === user.id)
    },
    managerModifyStateShown (ticket) {
      return !['Descartada', 'Duplicada', 'Tancada'].includes(ticket.estat.displayname)
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App },
  template: '<App/>'
})
